import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import { filterByLanguage, jsonldLiteralToString } from "../../../utils/functions.js";
import BarLoader from "react-spinners/BarLoader";
import { checkFilter } from "../../../utils/AnnotationEditGroupAPI.js";

export class AnnotationValuesModal extends Component {
  constructor(props) {
    super(props);

    this.state = this.createState(props);

    this.filter = props.filter;
  }

  componentWillReceiveProps(props) {
    var update = false;
    if (this.props.page !== props.page || this.props.mode !== props.mode) {
      update = true;
    }
    if (this.props.state === null ||
        (this.props.state !== null && (this.props.state.loaded !== props.state.loaded || this.props.state.loading !== props.state.loading || this.props.state.failed !== props.state.failed))) {
      update = true
    }

    this.filter = props.filter;

    if (update) {
      //this.setState(this.createState(props), ()=>this.resolveLabels());
      this.setState(this.createState(props));
      // console.log("update");
    }
}

descr(str) {
  if (str.length > 400) {
    return str.substring(0,400) + "..."
  } else {
    return str
  }
}

hightlightArray(el, input, array) {
  var str = '';
  if (input.lexicalForm) {
    str = input.lexicalForm
  } else if (input.iri) {
    str = input.iri
  }
  var result = ""
  if (!array || array.length === 0) {
    result = str
  } else {
    // var prev = 0;
    var index = 0;
    // var last = -1;
    // while (index < array.length) {
    //   if (array[index].start === undefined || array[index].end === undefined || array[index].start < 0 || array[index].end < 0)  {
    //     index++;
    //     continue;
    //   }
    //   last = index;
    //   var s = array[index].start;
    //   var e = array[index].end;
    //   result += str.substr(prev,s - prev);
    //   for (var i = index + 1; i < array.length;) {
    //     var nextElement = array[i];
    //     if (nextElement.start && nextElement.end && e > nextElement.start) {
    //       if (nextElement.end >= e) {
    //         e = nextElement.end;
    //       }
    //       index++;
    //       i++;
    //     } else {
    //       break;
    //     }
    //   }
    //   result += '<span id="element'+ el + '-' + index + '" class="highlight">' +  str.substr(s, e - s) +  '</span>';
    //   index++;
    //   prev = e;
    // }
    // if (last >= 0) {
    //   result += str.substr(array[last].end);
    // }
    // else {
    //   result = str;
    // }

    var iarray = [];
    while (index < array.length) {
       if (array[index].start === undefined || array[index].end === undefined || array[index].start < 0 || array[index].end < 0)  {
         index++;
         continue;
       }

       var element = array[index];

       iarray.push({ loc: element.start, type: 'start', element: index, value:element.value} )
       iarray.push({ loc: element.end, type: 'end', element: index, value:element.value} )

       index++;
    }

    var consumed = 0;

    iarray.sort(this.sortIarray);

    for (var i in iarray) {
      var element = iarray[i];

      if (consumed < element.loc) {
        result += str.substr(consumed, element.loc - consumed)
        consumed = element.loc
      }

      if (element.type === 'start') {
        result += '<span title="' + element.value + '" id="element'+ el + '-' + element.element + '" class="highlight">'
      } else if (element.type === 'end') {
        result += '</span>';
      }
    }

    if (str.length > consumed) {
      result += str.substr(consumed);
    }

  }
  return "<code ><pre class='mb-0'>" +  result + (input.language ? '<div><span title="Literal language" class="litlanguage">' + input.language  + '</span></div>': "") + "</pre></code>";
}

sortIarray(a,b) {
  if (a.loc < b.loc) {
    return -1;
  } else if (a.loc > b.loc) {
    return 1;
  } else if (a.type === 'start' && a.type === 'end') {
    return 1;
  } else if (a.type === 'start' && a.type === 'start') {
    if (a.element < b.element) {
      return 1;
    } else if (a.element > b.element) {
      return -1;
    } else {
      return 0;
    }
  } else if (a.type === 'end' && a.type === 'end') {
    if (a.element > b.element) {
      return 1;
    } else if (a.element < b.element) {
      return -1;
    } else {
      return 0;
    }
  }
}

  createState(props) {
      var state = {};
      var keys = [];

if (props.values) {
      for (const i in props.values.data) {
        keys.push(i);

        var details = [];
        for (const j in props.values.data[i].details) {
          var el = {...props.values.data[i].details[j]}

          if (el.state === 'ADD') {
            el = {...el, originalValue: el.value, originalValue2: el.value2}
          }
          if (el.state) {
            el = {...el, originalState: el.state}
          }

          details.push(el);
        }


        state['element' + i] = { index: props.values.data[i].index, count: props.values.data[i].count, value: props.values.data[i].onValue, details,  deleted: [], accepted: [] };

        // var values = new Map();
        // var details = [];
        // for (const j in props.value[i].details) {
        //   var el = {...props.value[i].details[j]}
        //
        //   var data = values.get(props.value[i].details[j].value);
        //   if (!data) {
        //     data = de;
        //     values.put(props.value[i].details[j].value, array);
        //   }
        //
        //   if (el.state === 'ADD') {
        //     el = {...el, originalValue: el.value, originalValue2: el.value2}
        //   }
        //   if (el.state) {
        //     el = {...el, originalState: el.state}
        //   }
        //
        //   details.push(el);
        // }
        //
        //
        // state['element' + i] = { value: props.value[i].onValue, details,  deleted: [], accepted: [] };

      }
}

      state.keys = keys
      state.filterCheck = { fields: [] }


      // console.log(state);

      return state;
  }

  setFilter(type, field, value) {
    var fields = this.filter.fields;
    if (!value) {
      fields = fields.filter(v => v.field !== field)
    } else {
      if (!fields.find(v => v.field == field)) {
          fields.push({field, value})
      } else {
        fields = fields.map(v => v.field == field ? {field, value} : v)
      }
    }
    this.filter = {...this.filter, fields}

  }

  viewAnnotations(action, id, page, mode) {
    if (this.filter != null && this.filter.fields.length > 0) {
      var _this = this;
      checkFilter(this.filter)
        .then((response) => {
          this.setState({ filterCheck: response.data })

          for (var el of response.data.fields) {
            if (!el.valid) {
              return
            }
          }

          _this.props.actions(action, {id, page, mode, annotators: _this.props.annotators, filter: _this.filter })
        })
        .catch(error => {
        //   throwToast('error', error.message);
        })
    } else {
      this.props.actions(action, {id, page, mode, annotators: this.props.annotators, filter: this.filter })
    }
  }

  render() {


    return (
      <Modal size="xl" show={this.props.show} onHide={() => this.props.onClose()} animation={false} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Annotations Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
        {this.props.state.loading &&
          <Col className="loader">
            <BarLoader
              css='spinner'
              height={6}
              width={200}
              color='crimson'
              loading={true}/>
          </Col>
        }
        {this.props.state.failed &&
          <Col>
            <span className="error">Loading values failed.</span>
          </Col>
        }
        {this.props.state.loaded &&
          <React.Fragment>

            <Row className="py-2 mx-0 border-bottom">
              <Col md="2">
                <Row>
                  <Col>Annotations: {this.props.values.metadata.totalCount}</Col>
                </Row>
                <Row>
                  <Col>Annotated items: {this.props.values.metadata.distinctSourceTotalCount}</Col>
                </Row>
              </Col>
              <Col md="6">
                <Row>
                  <Col md="4">Distinct annotated values</Col>
                  <Col md="8">Filter</Col>
                </Row>
                {this.props.values.metadata.distinctValueTotalCount && this.props.values.metadata.distinctValueTotalCount.map((el, index) =>
                <Row key={index}>
                  <Col md="4">{el.field}: {el.count}</Col>
                  <Col md="8">
                    <Form.Control className={'fieldInput ' + (this.state.filterCheck.fields.find(v => v.field == el.field) ? (this.state.filterCheck.fields.find(v => v.field == el.field).valid ? '' : ' fieldError') : '')}
                        defaultValue={this.props.filter && this.props.filter.fields.find(v => v.field == el.field) ? this.props.filter.fields.find(v => v.field == el.field).value : '' }
                        onChange={(event) => this.setFilter('field', el.field, event.target.value)}
                    />
                  </Col>
                </Row>)}
                {/*this.props.values.distinctValueTotalCount && this.props.values.distinctValueTotalCount.length == 1 && <Col>Distinct annotated values: {this.props.values.distinctValueTotalCount[0].count}</Col>*/}
              </Col>

              <Col md="4" className="d-inline-flex justify-content-end annotatorModalButtons">
              {this.props.annotators &&
                  <ButtonGroup className="annotationFilters pr-3">
                    <Button variant={this.props.mode==='ALL' ? "primary" : "secondary"} onClick={() => this.viewAnnotations('view-annotations', this.props.id, 1, 'ALL')}>All</Button>
                    <Button variant={this.props.mode==='ANNOTATED_ONLY' ? "primary" : "secondary"} onClick={() => this.viewAnnotations('view-annotations', this.props.id, 1, 'ANNOTATED_ONLY')}>Annotated</Button>
                    <Button variant={this.props.mode==='UNANNOTATED_ONLY' ? "primary" : "secondary"} onClick={() => this.viewAnnotations('view-annotations', this.props.id, 1, 'UNANNOTATED_ONLY')}>Not Annotated</Button>
                  </ButtonGroup>
              }
              </Col>
          </Row>
            <Row className="py-2 mx-0 border-bottom">
              <Col className="d-inline-flex justify-content-end">
                <span className="pr-4 font-weight-bold font-size-3">Annotated text</span>
              </Col>
              <Col className="d-inline-flex justify-content-center">
                <span className="pl-4 font-weight-bold font-size-3">Items count</span>
              </Col>
              <Col className="d-inline-flex justify-content-start">
                <span className="pl-4 font-weight-bold font-size-3">Annotation</span>
              </Col>
            </Row>


            <div className="scrollContainer">
              <div className="scroll">
                {this.state.keys.map((el,elindex) =>
                  <Row className="grouping bottomrow"  key={elindex}>
                    <Col md="auto align-items-center pt-2">
                       <span className="sticky-value">{this.state['element' + el].index}</span>
                    </Col>
                    <Col className="property-value align-items-center pr-1">
                      {this.state['element' + el].value.terms && this.state['element' + el].value.terms.map((term, index) =>
                        <div className="ann-extra-field-key">{term.name}
                          <div className="sticky-value" key={index} dangerouslySetInnerHTML={{__html: this.hightlightArray(el, term, this.state['element' + el].details)}}></div>
                        </div>)
                      }
                      {!this.state['element' + el].value.terms &&
                        <div className="sticky-value" dangerouslySetInnerHTML={{__html: this.hightlightArray(el, this.state['element' + el].value, this.state['element' + el].details)}}></div>
                      }
                    </Col>
                    <Col md="auto align-items-center pt-2">
                      <Container className="annotation-uris sticky-value">
                      <Row><span title="Items count" className="annotation-uris-count">{this.state['element' + el].count && this.state['element' + el].count}</span></Row>
                      </Container>
                    </Col>

                    <Col className="pl-1 pr-2">
                      <Container>
                        {this.state['element' + el].details.map((ann,index) =>
                        <Row key={index} className="td-row align-items-center align-self-center "
                              onMouseOver={()=>  document.getElementById('element'+el + '-' + index) ? document.getElementById('element'+el + '-' + index).classList.add('highlight-selected') : null}
                              onMouseOut={()=> document.getElementById('element'+el + '-' + index) ?  document.getElementById('element'+el + '-' + index).classList.remove('highlight-selected') : null}>

                          <Col className="pl-5">
                            <Row>
                            {ann.value2 ?
                              <Col>
                                <Row>
                                  <a href={ann.value} rel='noreferrer noopener' target="_blank"><span className="td-normal">{ann.value}</span></a> -
                                </Row>
                                <Row>
                                  <a href={ann.value2} rel='noreferrer noopener' target="_blank"><span className="td-normal">{ann.value2}</span></a>
                                </Row>
                              </Col>
                            :
                              (ann.value !== null ? <a href={ann.value} rel='noreferrer noopener' target="_blank"><span className="td-normal">{ann.value}</span></a> : '')
                            }
                            </Row>

                            {(ann.label && ann.label[0]) &&
                              <Row className="annotation-info">
                                 <span title="Annotation label" className="td-label annotation-label">{filterByLanguage(ann.label[0],'label', this.props.language, 'value', 'language')}</span>
                                 {(ann.label2 && ann.label2[0]) &&
                                 <span title="Annotation label" className="td-label annotation-label"> - {filterByLanguage(ann.label2[0],'label', this.props.language, 'value', 'language')}</span>}
                              </Row>
                            }

                            {ann.label && ann.label[0] && filterByLanguage(ann.label[0],'description', this.props.language, 'value', 'language') &&
                              <Row>
                                <span title="Annotation description" className="td-label description">{this.descr(filterByLanguage(ann.label[0],'description', this.props.language, 'value', 'language'))}</span>
                              </Row>
                            }

                            {ann.fields && <div className="ann-extra"> {Object.entries(ann.fields).map(([key, value], index) =>
                              <Row  className="ann-extra-field">
                              <Col><Row>
                                  <div className="ann-extra-field-key">{key}</div>
                                </Row>
                                <Row>
                                  <div className="ann-extra-field-value">{this.descr(value)}</div>
                                                              </Row></Col></Row>

                              )} </div>}

                            {ann.controlGraph &&
                            <Row className="control-graph-info">
                              <Col >
                                {(Array.isArray(ann.controlGraph["@graph"]) ? ann.controlGraph["@graph"] : [ann.controlGraph["@graph"]]).map(entry => Object.entries(entry).filter(([key, value]) => key != "@id" && key != "@type").map(([key, value]) => { return (
                                  <React.Fragment>
                                    <Row>
                                      <Col>
                                        <div className="control-prop-key">{key}</div>
                                      </Col>
                                    </Row>
                                    {(Array.isArray(value) ? value : [value]).map(v =>
                                    <Row>
                                      <Col>
                                        {!v.startsWith("http") &&
                                           <div className="control-prop-value">{jsonldLiteralToString(v)}</div>
                                        }
                                        {v.startsWith("http") &&
                                           <a href={v} rel='noreferrer noopener' target="_blank"><div className="control-prop-value">{jsonldLiteralToString(v)}</div></a>
                                        }
                                      </Col>
                                    </Row>)}
                                  </React.Fragment>)}))}
                              </Col>
                            </Row>}

                            {ann.score !== null && ann.score !== undefined &&
                              <Row>
                                <span title="Annotation score" className="td-label score">{ann.score.toFixed(3)}</span>
                              </Row>
                            }

                            {ann.annotatorInfo &&
                              <Row><Col md={12} className="ann-annotator">
                                {ann.annotatorInfo.name}
                              </Col></Row>
                            }
                          </Col>
                        </Row>
                      )}
                      </Container>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </React.Fragment>
        }
        </Modal.Body>
        <Modal.Footer>
          <Row className="modalFooter">
            <Col />
            <Col className="d-inline-flex justify-content-center">
              <Button
                type="button"
                disabled={!this.props.page || this.props.page === 1}
                variant="outline-light"
                aria-label="Previous"
                className="nextbutton px-5"
                onClick={() => this.viewAnnotations(this.props.action, this.props.id, this.props.page - 1, this.props.mode)}
              >
                <span className="fa fa-angle-double-left"/>
              </Button>
              <Button
                type="button"
                disabled={this.state.keys.length < 5}
                variant="outline-light"
                aria-label="Next"
                className="nextbutton px-5"
                onClick={() => this.viewAnnotations(this.props.action, this.props.id, this.props.page + 1, this.props.mode)}
              >
                <span className="fa fa-angle-double-right"/>
              </Button>
            </Col>
            <Col className="d-inline-flex justify-content-end px-0">
              <Button variant="secondary" onClick={() =>this.props.onClose()}>
                Close
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
  )}
}

export default AnnotationValuesModal;
